<script>
	export let name;
</script>

<style>
	h1, h2 {
		color: purple;
	}
	p {
		color:darkblue;
	}
</style>

<h1>Hello {name}!</h1>
<h3>New Year 2020 Wishes!</h3>
<p>Site is currently being developed. Target completion before the end of Q1 2020.</p>

<p>Last Updated: 20-Jan-2020</p>